import type { SessionStatus } from '../api/types.js';
import { StatusBadge } from './status-badge.js';

export function SessionStatusBadge({ status }: { status: SessionStatus }) {
  return <StatusBadge status={status} />;
}
